import React from 'react';

import {RowNumbered} from 'src/components/row-numbered';

import {Cell} from '@pb/kit-component-data-table-v2';


import {mainColumnCell, mainColumnCellAdornment, mainColumnCellLabel, mainColumnCellWithAdornment} from './main-column-cell.module.styl';

import type {CellOptions} from '@pb/kit-component-data-table-v2';

type Props = {
    children: React.ReactNode,
    selection?: React.ReactNode,
    endAdornment?: React.ReactNode,
    reserveSelectionSpace?: boolean,
    maxRowNumber: number,
    rowNumber?: number,
    rowId?: number,
    cellOptions: CellOptions,
};

export const MainColumnCell: React.FC<Props> = props => {
    const {
        rowNumber,
        children,
        selection,
        endAdornment,
        reserveSelectionSpace = true,
        maxRowNumber,
        cellOptions,
    } = props;

    return (
        <Cell {...cellOptions}>
            <div className={`${mainColumnCell} ${endAdornment ? mainColumnCellWithAdornment : ''}`}>
                {rowNumber ? (
                    <RowNumbered rowNumber={rowNumber} maxRowNumber={maxRowNumber}/>
                ) : <div style={{width: 30}}/>}
                {reserveSelectionSpace ? (
                    <div style={{width: 50, minWidth: 50}}>
                        {selection}
                    </div>
                ) : null}
                <div className={mainColumnCellLabel}>
                    {children}
                </div>
                {endAdornment ? <div className={mainColumnCellAdornment}>{endAdornment}</div> : null}
            </div>
        </Cell>
    );
};
